import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Space } from './space.interface';

export interface SpaceState {
   space?: Space;
}

const SpaceStore: Module<SpaceState, StoreState> = {
   namespaced: true,

   state: {
      space: undefined,
   },
   getters: {},

   mutations: {
      SET(state: any, space: Space) {
         state.space = space;

         if (!space) localStorage.removeItem('space');
         else if (space.board_id && space.board_id !== '') localStorage.setItem('space', JSON.stringify(space));
      },
   },

   actions: {},
   modules: {},
};

export default SpaceStore;
